var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.318708 1.18643C0.441137 0.920425 0.707184 0.75 1.00001 0.75H19C19.2928 0.75 19.5589 0.920425 19.6813 1.18643C19.8037 1.45243 19.7602 1.76537 19.5697 1.9878L12.55 10.1861V18C12.55 18.2593 12.4161 18.5002 12.1959 18.637C11.9757 18.7739 11.7004 18.7873 11.4679 18.6725L7.86793 16.8947C7.61201 16.7683 7.45001 16.5076 7.45001 16.2222V10.1861L0.430313 1.9878C0.239861 1.76537 0.196279 1.45243 0.318708 1.18643ZM2.62955 2.25L8.76971 9.42109C8.88606 9.55698 8.95001 9.72999 8.95001 9.90889V15.7561L11.05 16.7932V9.90889C11.05 9.72999 11.114 9.55698 11.2303 9.42109L17.3705 2.25H2.62955Z",
    fill: "#0E9658"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.f22cf52d4ddcfb463aa0b51b8e3cd568.svg";
export { ForwardRef as ReactComponent };